/* unplugin-vue-components disabled */import { render } from "./StoneSaleRank.vue?vue&type=template&id=56f36fad&scoped=true&ts=true"
import script from "./StoneSaleRank.vue?vue&type=script&lang=ts"
export * from "./StoneSaleRank.vue?vue&type=script&lang=ts"

import "./StoneSaleRank.vue?vue&type=style&index=0&id=56f36fad&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f36fad"]])

export default __exports__